import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import { TableCellProps } from 'react-virtualized';

import { TableColumn } from 'components/virtualized-table/virtualized-table-types';

interface OrderHistoryArchivalUnit {
  id: string;
  archivalCollection_evidenceNumber: string;
  archivalCollection_id: string;
  archivalCollection_mark: string;
  numericId: number;
  summary: string;
  timeRange?: string;
  activeReservation?: boolean;
  activeCopy?: boolean;
}

const RedirectLink = ({ cellData, dataKey, rowData }: TableCellProps) => {
  let href = {
    loans: '',
    history: '',
  };
  let analogContentOnTheWay = false;

  const baseUrl = `${process.env.PUBLIC_URL}/portfolio`;

  if (dataKey === 'activeReservation') {
    href.loans = `${baseUrl}/vypujcky/papirove`;
    href.history = `${baseUrl}/historie-vypujcek/papirove`;
    if (rowData?.activeCopy) {
      analogContentOnTheWay = true;
    }
  }

  if (dataKey === 'activeCopy') {
    const activeCopyId = rowData?.activeCopy_id;
    href.loans = `${process.env.PUBLIC_URL}/soukrome-archivalie/0/${activeCopyId}`;
    href.history = `${baseUrl}/historie-vypujcek/digitalni`;
  }

  return cellData != null ? (
    <Button
      variant="text"
      style={{ padding: '0 5px', borderRadius: 2 }}
      disabled={analogContentOnTheWay}
    >
      <a
        href={cellData === true ? href.loans : href.history}
        target="__blank"
        rel="noopener noreferer"
        style={{
          textDecoration: 'none',
          cursor: 'pointer',
          color: '#CF2930',
          textTransform: 'none',
        }}
      >
        {analogContentOnTheWay ? 'Na cestě' : 'Otevřít'}
      </a>
    </Button>
  ) : (
    <>-</>
  );
};

export const archivalUnitColumns: TableColumn<OrderHistoryArchivalUnit>[] = [
  {
    name: 'Identifikátor',
    datakey: 'numericId',
    width: 120,
  },
  {
    name: 'Archivní soubor',
    datakey: '',
    width: 200,
    CellComponent: function Prolink({ rowData }) {
      const row = rowData as OrderHistoryArchivalUnit;

      return (
        <a
          href={`${process.env.PUBLIC_URL}/fondy/0/${row.archivalCollection_id}`}
          target="__blank"
          rel="noopener noreferer"
          style={{
            cursor: 'pointer',
            textDecoration: 'none',
            color: '#CF2930',
            fontWeight: 'bold',
          }}
        >
          {row.archivalCollection_mark}
        </a>
      );
    },
  },
  {
    name: 'Obsah archiválie',
    datakey: 'summary',
    width: 200,
    CellComponent: function Summary({ cellData }) {
      return (
        <Tooltip title={`${cellData}`} placement="top" interactive>
          <span>{cellData ? cellData : '-'}</span>
        </Tooltip>
      );
    },
  },
  {
    name: 'Časový rozsah',
    datakey: 'timeRange',
    width: 200,
  },
  {
    name: 'Analogové',
    datakey: 'activeReservation',
    width: 100,
    CellComponent: RedirectLink,
  },
  {
    name: 'Digitální',
    datakey: 'activeCopy',
    width: 100,
    CellComponent: RedirectLink,
  },
];
